import { Feature } from '@/components/Modals/SignUp/components/CardPlan';
import StyledPrice from '@/components/Modals/SwitchToYearly/components/StyledPrice';
import { Card } from '@music-vine/cadence/ui';
import { StackingCardList } from '@music-vine/cadence/ui';
import { Text } from '@music-vine/cadence/ui';
import { usePricingOptions } from '@/hooks/api/usePricingOptions';
import { useCurrency } from '@/hooks/billing/useCurrency';
import { ProrationBillingMode } from '@/hooks/billing/useProration';
import type { Plan } from '@/features/Downloads/Gateway';
import type { PricingByCurrency } from '@/hooks/api/usePricingOptions';
const MINOR_UNITS_MULTIPLIER = 100;
const UpgradeCard = ({
  plan,
  billingMode
}: {
  plan: Plan['name'];
  billingMode: ProrationBillingMode;
}) => {
  const currency = useCurrency();
  const {
    data: pricingOptions
  } = usePricingOptions();
  const currentPlanData = pricingOptions?.find(_plan => _plan.title === plan);
  const currencyCode = currency?.code ?? 'GBP';
  const currencyCodeLower = currencyCode.toLowerCase() as keyof PricingByCurrency;
  const valueInMinorUnits = billingMode === ProrationBillingMode.MONTHLY ? Number(currentPlanData?.pricing[currencyCodeLower].monthly) * MINOR_UNITS_MULTIPLIER : Number(currentPlanData?.pricing[currencyCodeLower].yearly) * MINOR_UNITS_MULTIPLIER;
  const frequencyLabel = billingMode === ProrationBillingMode.MONTHLY ? '/month' : '/year';
  return <Card className="space-y-2 rounded-2xl border-pink-500 bg-pink-50 px-5 py-5 shadow-none dark:border-pink-500 dark:bg-pink-950/30" data-sentry-element="Card" data-sentry-component="UpgradeCard" data-sentry-source-file="UpgradeCard.tsx">
      <div className="flex justify-between gap-2 p-0">
        <div className="space-y-1">
          <Text asChild className="font-sans font-semibold text-base text-gray-950 dark:text-white" data-sentry-element="Text" data-sentry-source-file="UpgradeCard.tsx">
            <h3>Uppbeat {plan}</h3>
          </Text>
          <Text className="text-xs" data-sentry-element="Text" data-sentry-source-file="UpgradeCard.tsx">New plan</Text>
        </div>
        <div>
          <StyledPrice classNames={{
          symbol: 'text-xs text-gray-700 dark:text-gray-300',
          integer: 'text-base font-sans font-semibold text-gray-950 dark:text-white',
          decimal: 'text-base font-sans font-semibold text-gray-950 dark:text-white'
        }} currency={currencyCode} valueInMinorUnits={valueInMinorUnits} data-sentry-element="StyledPrice" data-sentry-source-file="UpgradeCard.tsx" />
          <span className="text-gray-700 text-xs dark:text-gray-300">
            {frequencyLabel}
          </span>
        </div>
      </div>
      <div className="flex flex-col gap-1.5">
        <StackingCardList className="px-0 py-0" data-sentry-element="StackingCardList" data-sentry-source-file="UpgradeCard.tsx">
          {currentPlanData?.benefits.map(benefit => <Feature key={benefit} tooltipSide="bottom" variant="uppbeat">
              {benefit.replace('-', '').trim()}
            </Feature>)}
        </StackingCardList>
      </div>
    </Card>;
};
export default UpgradeCard;